import React from "react";

import Box from "../Box";
import { BigQueryComparative } from "../../types/commercial";

import styled from "styled-components";
import MrclText from "../marcel/MrclText";
import BaseDashboardCard from "../BaseDashboardCard";
import { computeRHRate } from "../../utils/turnover";
import useBreakPoint from "../../utils/useBreakPoint";
import DeltaBadge from "../DeltaBadge";
import { Store } from "../../types/store";
import { useTranslation } from "react-i18next";

type ComparativeCardProps = {
  listValue: Array<BigQueryComparative>;
  isUnavailable: boolean;
  isLoading: boolean;
  storeType: Store["storeType"];
  openInformationModal: (title?: string) => void;
};

const Table = styled.table`
  width: 100%;
`;
const Tr = styled.tr``;
const Th = styled.th<{ $textAlign?: string }>`
  text-align: ${(props) => props?.$textAlign};
`;
const Td = styled.td<{ $textAlign?: string }>`
  text-align: ${(props) => props?.$textAlign};
  padding-block: 8px;
`;
const CTextCustum = styled(MrclText)<{ with?: string }>`
  font-family: system-ui;
  min-width: ${(props) => (props?.with ? props?.with : "5rem")};
`;
const Text = styled(MrclText)`
  font-family: system-ui;
`;

const ComparativeCard = ({
  listValue,
  storeType,
  ...res
}: ComparativeCardProps) => {
  const isBreak = useBreakPoint();
  const {t} =useTranslation();

  return (
    <BaseDashboardCard
      hasModal={true}
      {...res}
      title={t('commercial.comparatif_ca')}
      subTitle={t('commercial.hors_ecommerce')}
      openInformationModal={() => null}
      importedDateTime={listValue?.[0]?.importedDateTime}
      size={"big"}
      width={"100%"}
    >
      <Box alignItems="center" justifyContent={"center"} width="100%" py={2}>
        <Table>
          <thead>
            <Tr>
              <Th></Th>
              <Th>
                <Text bold size={"s"} tagStyle={"p"}>
                  {t('commercial.magasin')}
                </Text>
              </Th>
              <Th $textAlign={"center"}>
                <Text bold size={"s"} tagStyle={"p"}>
                  {t('commercial.region')}
                </Text>
              </Th>
              <Th $textAlign="center">
                <Text bold size={"s"} tagStyle={"p"}>
                  {`${storeType === "market" ? "France" : "Rang"}`}
                </Text>
              </Th>
            </Tr>
          </thead>
          <tbody>
            {listValue &&
              listValue?.length > 0 &&
              listValue.map((comparative: BigQueryComparative, index) => {
                const region = computeRHRate(
                  comparative.regionalTurnover,
                  comparative.lastYearRegionalTurnover
                ) as number;
                const magasin = computeRHRate(
                  comparative.turnover,
                  comparative.lastYearTurnover
                ) as number;
                const nationalOrRank =
                  storeType === "market"
                    ? (computeRHRate(
                        comparative.nationalTurnover,
                        comparative.lastYearNationalTurnover
                      ) as number)
                    : (Number(comparative.storeRank) as number);

                return (
                  <Tr key={"sec" + comparative.sector}>
                    <Td $textAlign={"left"}>
                      <Text
                        tagStyle={isBreak === "phone" ? "caption" : "p"}
                      >
                        {comparative.sector}
                      </Text>
                    </Td>
                    <Td>
                      {magasin && !isNaN(magasin) && isFinite(magasin) ? (
                       <DeltaBadge value={magasin} />
                      ) : (
                        "-"
                      )}
                    </Td>
                    <Td $textAlign={"center"}>
                      {region && !isNaN(region) && isFinite(region) ? (
                       <DeltaBadge value={region} />
                      ) : (
                        "-"
                      )}
                    </Td>
                    <Td $textAlign="center">
                      {storeType === "market"
                        ? nationalComponent(nationalOrRank)
                        : rankComponent(nationalOrRank)}
                    </Td>
                  </Tr>
                );
              })}
          </tbody>
        </Table>
      </Box>
    </BaseDashboardCard>
  );
};

export default ComparativeCard;

function nationalComponent(national: number) {
  return (
    <Box>
      {national && !isNaN(national) && isFinite(national) ? (
      <DeltaBadge value={national} />
      ) : (
        "-"
      )}
    </Box>
  );
}

function rankComponent(rank: number) {
  return (
    <Box display={"flex"} justifyContent={"center"} alignContent={"center"}>
      <Box
        bg={"#F5FAFF"}
        width={5}
        borderRadius={"4px"}
        display={"flex"}
        justifyContent={"center"}
        alignContent={"center"}
      >
        {rank && !isNaN(rank) && isFinite(rank) ? (
          <CTextCustum bold>
            {new Intl.NumberFormat("fr-FR", {
              maximumFractionDigits: 0,
            }).format(rank)}
          </CTextCustum>
        ) : (
          "-"
        )}
      </Box>
    </Box>
  );
}
